const checkShade = (targetShade, condition) => {
  const shade = Number(targetShade);
  const permissibleShades = [0, 50, 100, 200, 300, 300, 400, 500, 600, 700, 800, 900, 1000];

  if (Number.isNaN(shade) || !permissibleShades.includes(shade)) {
    throw new Error(`Incorrect value of targetShade`);
  }

  if (!condition) return true;

  return condition(shade);
};

export default checkShade;
